import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Chip,
  Box,
  Button,
  InputAdornment,
  Typography,
} from "@mui/material";
//IMPORTS PARA LO QUE HIZO NACHO.
import {
  AttachMoney as MoneyIcon,
  CreditCard as CreditCardIcon,
  AccountBalance as BankIcon,
} from "@mui/icons-material";

import EfectivoTab from "../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/MetodosDePago/EfectivoTab";
import InstrumentosTab from "../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/MetodosDePago/InstrumentosTab";
import TarjetasTab from "../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/MetodosDePago/TarjetasTab";

//#endregion
function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ py: 2 }}>{children}</Box>}{" "}
    </div>
  );
}

const TabsMediosPago = ({
  state,
  updateRecibo,
  handleImporteChange,
  clienteData,
  addInstrumento,
  updateInstrumento,
  removeInstrumento,
  addInstrumentosQr,
  tiposInstrumento,
  bancos,
  addTarjeta,
  updateTarjeta,
  removeTarjeta,
  tiposTarjeta,
  marcasTarjeta = [],
  recObligatorio = false,
}) => {
  const [tabActivo, setTabActivo] = useState(0);

  // // Contado / consumidor final: el recibo es obligatorio y solo se cobra en efectivo.
  // if (recObligatorio) {
  //   return (
  //     <div>
  //       <Box
  //         sx={{
  //           display: "flex",
  //           alignItems: "center",
  //           gap: 1,
  //           borderBottom: 1,
  //           borderColor: "divider",
  //           pb: 1.5,
  //         }}
  //       >
  //         <MoneyIcon color="success" />
  //         <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
  //           Pago en efectivo
  //         </Typography>
  //         <Chip
  //           label="Único medio de pago disponible para esta operación"
  //           size="small"
  //           sx={{ ml: 1 }}
  //         />
  //       </Box>
  //       <Box sx={{ py: 2 }}>
  //         <EfectivoTab
  //           efectivo={state.recibo.efectivo}
  //           onEfectivoChange={(value) => updateRecibo("efectivo", value)}
  //           redondeo={state.recibo.redondeo}
  //           onRedondeoChange={(value) => updateRecibo("redondeo", value)}
  //           handleImporteChange={handleImporteChange}
  //           ocultarRedondeo={true}
  //         />
  //       </Box>
  //     </div>
  //   );
  // }

  return (
    <div>
      <Box>
        <Tabs
          value={tabActivo}
          onChange={(e, newValue) => setTabActivo(newValue)}
          variant="fullWidth"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab icon={<MoneyIcon />} label="Efectivo" iconPosition="start" />
          <Tab
            icon={<BankIcon />}
            label={
              <Box display="flex" alignItems="center" gap={1}>
                Instrumentos
                {state.instrumentos.length > 0 && (
                  <Chip
                    label={state.instrumentos.length}
                    size="small"
                    color="primary"
                  />
                )}
              </Box>
            }
            iconPosition="start"
          />
          <Tab
            icon={<CreditCardIcon />}
            label={
              <Box display="flex" alignItems="center" gap={1}>
                Tarjetas
                {state.tarjetas.length > 0 && (
                  <Chip
                    label={state.tarjetas.length}
                    size="small"
                    color="primary"
                  />
                )}
              </Box>
            }
            iconPosition="start"
          />
        </Tabs>

        <TabPanel value={tabActivo} index={0}>
          <EfectivoTab
            efectivo={state.recibo.efectivo}
            onEfectivoChange={(value) => updateRecibo("efectivo", value)}
            redondeo={state.recibo.redondeo}
            onRedondeoChange={(value) => updateRecibo("redondeo", value)}
            handleImporteChange={handleImporteChange}
            ocultarRedondeo={true}
          />
        </TabPanel>

        <TabPanel value={tabActivo} index={1}>
          <InstrumentosTab
            instrumentos={state.instrumentos}
            clienteData={clienteData}
            onAdd={addInstrumento}
            onUpdate={updateInstrumento}
            onRemove={removeInstrumento}
            onAddInstrumentosQr={addInstrumentosQr}
            tiposInstrumento={tiposInstrumento}
            bancos={bancos}
            handleImporteChange={handleImporteChange}
          />
        </TabPanel>

        <TabPanel value={tabActivo} index={2}>
          <TarjetasTab
            tarjetas={state.tarjetas}
            onAdd={addTarjeta}
            onUpdate={updateTarjeta}
            onRemove={removeTarjeta}
            tiposTarjeta={tiposTarjeta}
            bancos={bancos}
            marcas={marcasTarjeta}
            handleImporteChange={handleImporteChange}
          />
        </TabPanel>
      </Box>
    </div>
  );
};

export default TabsMediosPago;
